import { EntAgroTransportItem } from "./agroTransportItem";
import { EntTerritorialsUnits } from "./handBooks/territorialsUnits";

export class EntTransport {

  id: number | null = null;
  agriculturalMachineryId: number | null = null;
  territorialUnitId: number | null = null;
  territorialUnit: EntTerritorialsUnits | null = null;
  nameKyTerritorialUnit: string | null = null;
  nameRuTerritorialUnit: string | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  details: EntAgroTransportItem[]  | null = null;
}